<template>
    <transition name="order-modal">
        <div class="tingle-modal order-modal-mask">
            <div
                class="tingle-modal-box order-modal-wrapper"
                :class="[{'order-modal-wrapper--infobox' : infobox}, {'order-modal-wrapper--private': mode}, {'order-modal-wrapper--form': form}]"
            >
                <div class="tingle-modal-box__content order-modal-container">
                    <slot name="content" />
                    <button
                        class="tingle-modal__close"
                        @click="closeModal">
                        <span lang="en">Close</span>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line

export default {
    props: {
        close: {
            type: String,
            required: true,
        },
        infobox: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: '',
        },
    },
    created() {
        $('html').addClass('scrolling-disabled');
    },
    destroyed() {
        $('html').removeClass('scrolling-disabled');
    },
    methods: {
        closeModal() {
            this.$store.commit(this.close);
        },
    },
};
</script>




// WEBPACK FOOTER //
// Modal.vue?1c56cc15